import { type StackPacksDetailsState, initialStackPacksDetailsState } from "./details/StackPacksDetailsState";
import { type StackPacksIndexState, initialStackPacksIndexState } from "./index/StackPacksIndexState";

export interface StackPacksState {
	index: StackPacksIndexState;
	details: StackPacksDetailsState;
}

export const initialStackPacksState: StackPacksState = {
	index: initialStackPacksIndexState,
	details: initialStackPacksDetailsState,
};
